import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';
import { FlatList, Pressable, View } from 'react-native';
import { brand } from 'src/theme/colors';
import { openWindow } from 'src/_shared/utils/open-window/openWindow';
import { style } from './PolicyPrivacyContent.styles';
import { useStore } from 'src/contexts/StoreContext';
import TextLato from '../text/text-lato/TextLato';

export const PolicyPrivacyContent = observer(() => {
  const { i18n } = useStore();
  const [hover, setHover] = useState<boolean>();

  const onPressLink = async () => {
    await openWindow('https://www.photosi.com/it/privacy-policy');
  };

  const firstParagraphPointsContent = useMemo(
    () => [i18n.t('modal-privacy-policy:paragraph-1-content-1'), i18n.t('modal-privacy-policy:paragraph-1-content-2')],
    [i18n],
  );

  const secondParagraphPointsContent = useMemo(
    () => [
      i18n.t('modal-privacy-policy:paragraph-2-content-1'),
      i18n.t('modal-privacy-policy:paragraph-2-content-2'),
      i18n.t('modal-privacy-policy:paragraph-2-content-3'),
    ],
    [i18n],
  );

  return (
    <>
      <TextLato style={style.text}>{i18n.t('modal-privacy-policy:main-content')}</TextLato>
      <View>
        <TextLato style={style.text}>{i18n.t('modal-privacy-policy:paragraph-1-title')}</TextLato>
        <FlatList
          data={firstParagraphPointsContent}
          renderItem={elem => {
            return (
              <View style={style.bulletContainer}>
                <View style={style.bullet} />
                <TextLato style={style.text}>{elem.item}</TextLato>
              </View>
            );
          }}
        ></FlatList>
      </View>
      <View>
        <TextLato style={style.text}>{i18n.t('modal-privacy-policy:paragraph-2-title')}</TextLato>
        <FlatList
          data={secondParagraphPointsContent}
          renderItem={elem => {
            return (
              <View style={style.bulletContainer}>
                <View style={style.bullet} />
                <TextLato style={style.text}>{elem.item}</TextLato>
              </View>
            );
          }}
        ></FlatList>
      </View>
      <View style={style.knowMoreWrapper}>
        <TextLato style={style.text}>{i18n.t('modal-privacy-policy:know-more-1')}&nbsp;</TextLato>
        <Pressable
          style={style.knowMoreLink}
          onHoverIn={() => setHover(true)}
          onHoverOut={() => setHover(false)}
          onPress={onPressLink}
        >
          <TextLato style={[{ color: brand.main.water }, hover && { textDecorationLine: 'underline' }]}>
            {i18n.t('modal-privacy-policy:privacy-policy')}
          </TextLato>
        </Pressable>
        <TextLato style={style.text}>&nbsp;{i18n.t('modal-privacy-policy:know-more-2')}</TextLato>
      </View>
      <TextLato style={style.text}>{i18n.t('modal-privacy-policy:thanks')}</TextLato>
    </>
  );
});

export default PolicyPrivacyContent;
